import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Settings from 'components/Settings'

export const SettingsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Settings />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
